import { useMemo } from "react";

import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter/model/types";
import { onScrollBottomSubdivision } from "~/hooks/selectSubdivisionValue";

/**
 * Адаптер списка подразделений (GraphQL `SubdivisionGetter`) под опции фильтра.
 * Нормализует `value` опции к строке (URL хранит строку).
 */
export const useSubdivisionOptions = (): FilterFieldOptionsHookResult => {
  const {
    divisionsForSelect,
    onScrollBottomDivisions,
    searchDivision,
    GetSubdivisionLoading,
  } = onScrollBottomSubdivision();

  const options = useMemo<FilterFieldOption[]>(
    () =>
      divisionsForSelect.map((o) => ({
        label: o.label,
        value: String(o.value),
      })),
    [divisionsForSelect],
  );

  return {
    options,
    loading: GetSubdivisionLoading,
    onScrollBottom: onScrollBottomDivisions,
    searchOptions: searchDivision,
  };
};
